/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useReducer, useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import {
  CHANGE_ACCOUNT_PASSWORD_SUBMIT,
  SEND_OTP
} from 'redux/sagas/actions/account';
import { SET_ACCESS_ERROR } from 'redux/slices/account';
import { Button, Input, Tooltip } from 'ui/atoms';
import MainFont from 'ui/typography/mainFont';
import validator from 'utils/regex-validator';

import {
  ForgotPasswordText,
  InsertEmailTextWrapper,
  ResendCode,
  RowForm,
  SendOTPText,
  SpinnerContainer,
  StatusInProgressIcon,
  SubmitWrapper
} from './style';
import { FORGOT_PASSWORD_RESEND_OTP } from '../../../redux/sagas/actions/authentication';
import spinnerIcon from 'ui/assets/img/spinner-icon.png';
import { SpinnerIcon } from '../../atoms/Table/style';
import {
  RESET_ERRORS,
  SET_ACCESS_ERROR_OTP,
  SET_ACCESS_ERROR_PASSWORD_NOT_MATCH,
  SET_ACCESS_ERROR_PASSWORD_NOT_VALID
} from '../../../redux/slices/authentication';

const reducer = (state, action) => {
  switch (action.type) {
    case 'add_password':
      return {
        ...state,
        password: action.payload
      };
    case 'add_confirm_password':
      return {
        ...state,
        confirm_password: action.payload
      };
    case 'code':
      return {
        ...state,
        code: action.payload
      };
    default:
      return state;
  }
};

const newField = () => '';

const initialState = {
  confirm_password: newField(),
  password: newField(),
  code: newField()
};

const ChangeAccountPassword = ({
  setError,
  changePasswordSubmit,
  sendOTP,
  account,
  otpStatus,
  error,
  errorType,
  resendOtp,
  closeModal,
  isLoading,
  setErrorPswDontMatch,
  setErrorPswNotValid,
  resetErrors,
  errorOtp,
  errorPswNotValid,
  errorPswDontMatch,
  setErrorOtp
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [otp, setotp] = useState(false);
  const [pageStatus, setpageStatus] = useState(false);
  const [formattedPasswordErrors, setFormattedPassordErrors] = useState('');
  const [showSpninner, setshowSpninner] = useState(false);
  const { t } = useTranslation();

  const handleValidation = useCallback(() => {
    if (!validator.atecoCode(state.code)) {
      setError(t('code_not_valid_otp'), 'code');
      return false;
    }
    if (!validator.password(state.password)) {
      setError(t('password_not_valid'), 'password');
      return false;
    }

    if (state.password !== state.confirm_password) {
      setError(t('password_not_match'), 'newPassword');
      return false;
    }

    setError('');
    return true;
  });

  const handleOTP = () => {
    sendOTP(account.email);
    setotp(true);
  };
  /*
  const handleResendOTP = () => {
    setshowSpninner(true);
    sendOTP(account.email);
    setotp(true);
  };*/

  const handleSubmitPasswword = () => {
    if (handleValidation()) {
      const { code, password } = state;
      setpageStatus(true);
      changePasswordSubmit({ code, password });
      // closeModal();
    }
  };

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      handleSubmitPasswword();
    }
  };

  useEffect(() => {
    if (
      state.password &&
      state.confirm_password &&
      state.password !== state.confirm_password
    ) {
      setErrorPswDontMatch(t('password_not_match'));
    } else {
      setErrorPswDontMatch(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.password, state.confirm_password]);

  useEffect(() => {
    if (state.password && !validator.password(state.password)) {
      setErrorPswNotValid(t('password_not_valid'));
    } else {
      setErrorPswNotValid(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.password]);

  useEffect(() => {
    if (errorPswNotValid && errorPswDontMatch) {
      if (errorPswDontMatch.toLowerCase().includes('confirm')) {
        setFormattedPassordErrors(
          `<ul><li>${t('password_not_match')}</li><li>${t(
            'confirm_psw_not_valid'
          )}</li></ul>`
        );
      } else {
        setFormattedPassordErrors(
          `<ul><li>${t('password_not_match')}</li><li>${t(
            'psw_not_valid'
          )}</li></ul>`
        );
      }
    } else if (errorPswDontMatch && !errorPswNotValid) {
      setFormattedPassordErrors(errorPswDontMatch);
    } else if (errorPswNotValid && !errorPswDontMatch) {
      setFormattedPassordErrors(errorPswNotValid);
    } else if (!errorPswNotValid && !errorPswDontMatch) {
      setFormattedPassordErrors('');
    }
  }, [errorPswNotValid, errorPswDontMatch]);

  useEffect(() => {
    if (
      !pageStatus &&
      (state.password || state.confirm_password || state.code)
    ) {
      handleValidation();
    }
    if (otpStatus) {
      setshowSpninner(false);
    }
  }, [handleValidation, state, otpStatus, pageStatus]);

  useEffect(() => {
    if (state.code && state.code.length !== 0) {
      if (!validator.atecoCode(state.code)) {
        setErrorOtp(t('code_not_valid'));
      } else {
        setErrorOtp(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.code]);

  const isDisabled = () =>
    !state.password ||
    !state.confirm_password ||
    !state.code ||
    formattedPasswordErrors ||
    errorOtp;

  return (
    <>
      <ForgotPasswordText>
        <MainFont
          configuration={{ fontSize: 15, fontWeight: 'medium' }}
          type="3"
        >
          {t('change_psw_text', {
            email: account?.email
          })}
        </MainFont>
      </ForgotPasswordText>
      {showSpninner ? <StatusInProgressIcon /> : null}
      <div onKeyPress={handleKeyPress}>
        {otp ? (
          <>
            {!isLoading ? (
              <>
                <InsertEmailTextWrapper
                  data-tip={`${t(errorOtp)}`}
                  data-for="otp-tooltip"
                >
                  <Input
                    type="number"
                    value={state.code}
                    placeholder={t('insert_the_code')}
                    variant="insertotp"
                    status={errorOtp ? 'invalid' : ''}
                    onChange={e =>
                      dispatch({
                        type: 'code',
                        payload: e.currentTarget.value
                      })
                    }
                  />
                </InsertEmailTextWrapper>
                {errorOtp && <Tooltip id="otp-tooltip" error />}
              </>
            ) : (
              <SpinnerContainer>
                <SpinnerIcon icon={spinnerIcon} />
              </SpinnerContainer>
            )}
            <SendOTPText>
              <MainFont configuration={{ fontSize: 12 }} type="3">
                {t('otp_message')}
              </MainFont>
              <ResendCode
                isLoading={isLoading}
                onClick={() => {
                  if (!isLoading) {
                    resendOtp();
                  }
                }}
              >
                <MainFont configuration={{ fontSize: 12 }} type="4">
                  {t('resend')}
                </MainFont>
              </ResendCode>
            </SendOTPText>
          </>
        ) : null}
        {!otp && !isLoading ? (
          <Button variant="changeaccountpassword" onClick={handleOTP}>
            <MainFont configuration={{ fontSize: 14 }} type="4">
              {t('send_otp')}
            </MainFont>
          </Button>
        ) : null}

        <ForgotPasswordText>
          <MainFont configuration={{ fontSize: 14 }} type="3">
            {t('create_password_text')}
          </MainFont>
        </ForgotPasswordText>
        <RowForm>
          <Input
            type="password"
            placeholder={t('new_password')}
            variant="changeaccountpassword"
            value={state.password}
            status={formattedPasswordErrors ? 'invalid' : ''}
            onChange={e =>
              dispatch({
                type: 'add_password',
                payload: e.currentTarget.value
              })
            }
            data-tip={`${formattedPasswordErrors}`}
            data-for="psw-tooltip"
            data-html
            isShowPassword
          />
          {formattedPasswordErrors && <Tooltip id="psw-tooltip" error />}
        </RowForm>
        <RowForm>
          <Input
            type="password"
            placeholder={t('confirm_password')}
            variant="changeaccountpassword"
            value={state.confirm_password}
            status={formattedPasswordErrors ? 'invalid' : ''}
            onChange={e =>
              dispatch({
                type: 'add_confirm_password',
                payload: e.currentTarget.value
              })
            }
            isShowPassword
          />
        </RowForm>
      </div>
      <SubmitWrapper>
        <Button
          variant="changepassword"
          disabled={isDisabled()}
          status={isDisabled()}
          name="changeaccountpassword"
          onClick={isDisabled() ? () => null : handleSubmitPasswword}
        >
          <MainFont configuration={{ fontSize: 14 }} type="4">
            {t('confirm')}
          </MainFont>
        </Button>
      </SubmitWrapper>
    </>
  );
};

ChangeAccountPassword.propTypes = {
  changePasswordSubmit: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  sendOTP: PropTypes.func,
  otpStatus: PropTypes.bool,
  error: PropTypes.string,
  errorType: PropTypes.string,
  account: PropTypes.object,
  resendOtp: PropTypes.func,
  closeModal: PropTypes.func,
  isLoading: PropTypes.bool,
  setErrorPswDontMatch: PropTypes.func.isRequired,
  setErrorPswNotValid: PropTypes.func.isRequired,
  resetErrors: PropTypes.func.isRequired,
  errorOtp: PropTypes.string,
  errorPswDontMatch: PropTypes.string,
  errorPswNotValid: PropTypes.string
};

export default connect(
  state => ({
    account: state?.authentication?.accountInfo,
    otpStatus: state?.account?.otpStatus,
    error: state?.account?.errorMessage,
    errorType: state?.account?.errorType,
    isLoading: state?.authentication?.isLoading,
    errorPswDontMatch: state?.authentication.errorPswDontMatch,
    errorPswNotValid: state?.authentication.errorPswNotValid,
    errorOtp: state?.authentication.errorOtp
  }),
  dispatch => ({
    sendOTP: payload => dispatch({ type: SEND_OTP._REQUEST, payload }),
    setError: (message, type) => dispatch(SET_ACCESS_ERROR({ message, type })),
    changePasswordSubmit: payload =>
      dispatch({ type: CHANGE_ACCOUNT_PASSWORD_SUBMIT._REQUEST, payload }),
    resendOtp: () => dispatch({ type: FORGOT_PASSWORD_RESEND_OTP._REQUEST }),
    setErrorPswDontMatch: payload =>
      dispatch(SET_ACCESS_ERROR_PASSWORD_NOT_MATCH(payload)),
    setErrorPswNotValid: payload =>
      dispatch(SET_ACCESS_ERROR_PASSWORD_NOT_VALID(payload)),
    resetErrors: () => dispatch(RESET_ERRORS()),
    setErrorOtp: payload => dispatch(SET_ACCESS_ERROR_OTP(payload))
  })
)(ChangeAccountPassword);
